// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Field from "../../resources/layout-and-structure/Field.res.js";
import * as React from "react";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as InputDateField from "../../resources/selection-and-input/InputDateField.res.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as RadioCardGroup from "../../resources/selection-and-input/RadioCardGroup.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as InputSelectField from "../../resources/selection-and-input/InputSelectField.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ToggleButtonGroup from "../../resources/actions/ToggleButtonGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputCheckboxField from "../../resources/selection-and-input/InputCheckboxField.res.js";
import * as InputPasswordField from "../../resources/selection-and-input/InputPasswordField.res.js";
import * as InputTextAreaField from "../../resources/selection-and-input/InputTextAreaField.res.js";
import * as InputDateRangeField from "../../resources/selection-and-input/InputDateRangeField.res.js";
import * as InputRadioGroupField from "../../resources/selection-and-input/InputRadioGroupField.res.js";
import * as InputDateFieldFastNav from "../../resources/selection-and-input/InputDateFieldFastNav.res.js";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";
import * as InputCountrySelectField from "../../resources/selection-and-input/InputCountrySelectField.res.js";
import * as InputSuggestionComboBoxField from "../../resources/selection-and-input/InputSuggestionComboBoxField.res.js";

function onlySignificantChars(value) {
  let digitsOnly = value.replace(/\D/g, "");
  if (value.startsWith("+")) {
    return "+" + digitsOnly;
  } else {
    return digitsOnly;
  }
}

function restrict(value) {
  let significant = onlySignificantChars(value);
  let maxLength = significant.startsWith("+") ? 16 : 15;
  return significant.slice(0, maxLength);
}

function significantCountBefore(text, index) {
  return onlySignificantChars(text.slice(0, index)).length;
}

function isSignificantChar(char) {
  return /[\d+]/.test(char);
}

function positionAfterNthSignificant(formatted, _index, _remaining) {
  while (true) {
    let remaining = _remaining;
    let index = _index;
    if (remaining <= 0) {
      return index;
    }
    if (index >= formatted.length) {
      return formatted.length;
    }
    if (isSignificantChar(formatted.charAt(index))) {
      if (remaining <= 1) {
        return index + 1 | 0;
      }
      _remaining = remaining - 1 | 0;
      _index = index + 1 | 0;
      continue;
    }
    _index = index + 1 | 0;
    continue;
  };
}

let PhoneNumberMask = {
  onlySignificantChars: onlySignificantChars,
  restrict: restrict,
  significantCountBefore: significantCountBefore,
  isSignificantChar: isSignificantChar,
  positionAfterNthSignificant: positionAfterNthSignificant
};

function Make(Params) {
  let useField = Params.useField;
  let Form__Elements__Inputs$Make$InputText = props => {
    let __onFocus = props.onFocus;
    let __copyable = props.copyable;
    let __disabled = props.disabled;
    let __autoTrim = props.autoTrim;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let autoTrim = __autoTrim !== undefined ? __autoTrim : true;
    let disabled = __disabled !== undefined ? __disabled : false;
    let copyable = __copyable !== undefined ? __copyable : false;
    let onFocus = __onFocus !== undefined ? __onFocus : () => {};
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    let onFocus$1 = props$1.onFocus;
    return JsxRuntime.jsx(InputTextField.make, {
      label: props.label,
      required: props$1.required,
      fieldAction: props.fieldAction,
      disabled: disabled,
      focused: props$1.focused,
      copyable: copyable,
      placeholder: props.placeholder,
      autoTrim: autoTrim,
      maxLength: props.maxLength,
      errorMessage: props$1.error,
      value: props$1.value,
      onChange: props$1.onChange,
      onFocus: () => {
        onFocus$1();
        onFocus();
      },
      onBlur: props$1.onBlur
    });
  };
  let InputText = {
    make: Form__Elements__Inputs$Make$InputText
  };
  let Form__Elements__Inputs$Make$InputSuggestionComboBox = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    return JsxRuntime.jsx(InputSuggestionComboBoxField.make, {
      label: props.label,
      required: props$1.required,
      focused: props$1.focused,
      placeholder: props.placeholder,
      errorMessage: props$1.error,
      items: props.items,
      value: props$1.value,
      onChange: props$1.onChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur
    });
  };
  let InputSuggestionComboBox = {
    make: Form__Elements__Inputs$Make$InputSuggestionComboBox
  };
  let Form__Elements__Inputs$Make$InputSelect = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputSelectField.make, {
      label: props.label,
      errorMessage: props$1.error,
      placeholder: props.placeholder,
      required: props$1.required,
      disabled: props.disabled,
      tooltip: props.tooltip,
      onChange: props$1.onChange,
      searchable: props.searchable,
      renderItem: props.renderItem,
      renderValue: props.renderValue,
      value: props$1.value,
      sections: props.sections
    });
  };
  let InputSelect = {
    make: Form__Elements__Inputs$Make$InputSelect
  };
  let Form__Elements__Inputs$Make$InputToggleButtonGroup = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let __grow = props.grow;
    let emptyValue = props.emptyValue;
    let grow = __grow !== undefined ? __grow : false;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    let onChange = props$1.onChange;
    let required = props$1.required;
    let disallowEmptySelection = Stdlib_Option.getOr(props.disallowEmptySelection, required || Stdlib_Option.isNone(emptyValue));
    return JsxRuntime.jsx(ToggleButtonGroup.make, {
      label: props.label,
      tooltip: props.tooltip,
      errorMessage: props$1.error,
      required: required,
      size: props.size,
      grow: grow,
      attached: props.attached,
      disallowEmptySelection: disallowEmptySelection,
      items: props.items,
      value: {
        TAG: "Single",
        _0: props$1.value
      },
      onChange: selection => {
        if (typeof selection !== "object") {
          return Stdlib_Option.forEach(emptyValue, onChange);
        } else if (selection.TAG === "Single") {
          return onChange(selection._0);
        } else {
          return;
        }
      }
    });
  };
  let InputToggleButtonGroup = {
    make: Form__Elements__Inputs$Make$InputToggleButtonGroup
  };
  let Form__Elements__Inputs$Make$InputCountrySelect = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let __subdivisionsIncluded = props.subdivisionsIncluded;
    let subdivisionsIncluded = __subdivisionsIncluded !== undefined ? __subdivisionsIncluded : false;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputCountrySelectField.make, {
      value: props$1.value,
      onChange: props$1.onChange,
      subdivisionsIncluded: subdivisionsIncluded,
      required: props$1.required,
      errorMessage: props$1.error
    });
  };
  let InputCountrySelect = {
    make: Form__Elements__Inputs$Make$InputCountrySelect
  };
  let Form__Elements__Inputs$Make$InputTextArea = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    return JsxRuntime.jsx(InputTextAreaField.make, {
      label: props.label,
      focused: props$1.focused,
      required: props$1.required,
      errorMessage: props$1.error,
      value: props$1.value,
      onChange: props$1.onChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur
    });
  };
  let InputTextArea = {
    make: Form__Elements__Inputs$Make$InputTextArea
  };
  let Form__Elements__Inputs$Make$InputPassword = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    return JsxRuntime.jsx(InputPasswordField.make, {
      label: props.label,
      value: props$1.value,
      focused: props$1.focused,
      required: props$1.required,
      errorMessage: props$1.error,
      onChange: props$1.onChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur,
      placeholder: props.placeholder,
      showTypingValidation: props.showTypingValidation
    });
  };
  let InputPassword = {
    make: Form__Elements__Inputs$Make$InputPassword
  };
  let Form__Elements__Inputs$Make$InputNumber = props => {
    let __autoFocused = props.autoFocused;
    let __shrinkInput = props.shrinkInput;
    let __precision = props.precision;
    let __useGrouping = props.useGrouping;
    let __disabled = props.disabled;
    let __hideStepper = props.hideStepper;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let hideStepper = __hideStepper !== undefined ? __hideStepper : false;
    let disabled = __disabled !== undefined ? __disabled : false;
    let useGrouping = __useGrouping !== undefined ? __useGrouping : true;
    let precision = __precision !== undefined ? __precision : 2;
    let shrinkInput = __shrinkInput !== undefined ? __shrinkInput : false;
    let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    return JsxRuntime.jsx(InputNumberField.make, {
      value: props$1.value,
      minValue: props.minValue,
      maxValue: props.maxValue,
      step: props.step,
      precision: precision,
      label: props.label,
      tooltip: props.tooltip,
      errorMessage: props$1.error,
      placeholder: props.placeholder,
      appender: props.appender,
      shrinkInput: shrinkInput,
      autoFocused: autoFocused,
      focused: props$1.focused,
      required: props$1.required,
      disabled: disabled,
      hideStepper: hideStepper,
      useGrouping: useGrouping,
      onChange: props$1.onChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur
    });
  };
  let InputNumber = {
    make: Form__Elements__Inputs$Make$InputNumber
  };
  let Form__Elements__Inputs$Make$InputOptionalNumber = props => {
    let __autoFocused = props.autoFocused;
    let __shrinkInput = props.shrinkInput;
    let __precision = props.precision;
    let __useGrouping = props.useGrouping;
    let __disabled = props.disabled;
    let __hideStepper = props.hideStepper;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let hideStepper = __hideStepper !== undefined ? __hideStepper : false;
    let disabled = __disabled !== undefined ? __disabled : false;
    let useGrouping = __useGrouping !== undefined ? __useGrouping : true;
    let precision = __precision !== undefined ? __precision : 2;
    let shrinkInput = __shrinkInput !== undefined ? __shrinkInput : false;
    let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    return JsxRuntime.jsx(InputNumberField.OptionalValue.make, {
      value: props$1.value,
      minValue: props.minValue,
      maxValue: props.maxValue,
      step: props.step,
      precision: precision,
      label: props.label,
      tooltip: props.tooltip,
      errorMessage: props$1.error,
      placeholder: props.placeholder,
      appender: props.appender,
      shrinkInput: shrinkInput,
      autoFocused: autoFocused,
      focused: props$1.focused,
      required: props$1.required,
      disabled: disabled,
      hideStepper: hideStepper,
      useGrouping: useGrouping,
      onChange: props$1.onChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur
    });
  };
  let InputOptionalNumber = {
    make: Form__Elements__Inputs$Make$InputOptionalNumber
  };
  let Form__Elements__Inputs$Make$InputRadioGroup = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputRadioGroupField.make, {
      label: props.label,
      value: props$1.value,
      required: props$1.required,
      onChange: props$1.onChange,
      errorMessage: props$1.error,
      options: props.options,
      optionToText: props.optionToText
    });
  };
  let InputRadioGroup = {
    make: Form__Elements__Inputs$Make$InputRadioGroup
  };
  let Form__Elements__Inputs$Make$InputRadioCardGroup = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let __disabled = props.disabled;
    let disabled = __disabled !== undefined ? __disabled : false;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(Field.make, {
      children: JsxRuntime.jsx(RadioCardGroup.make, {
        orientation: props.orientation,
        items: props.items,
        value: props$1.value,
        disabled: disabled,
        onChange: props$1.onChange
      }),
      label: props.label,
      tooltip: Stdlib_Option.map(props.tooltip, text => JsxRuntime.jsx(Tooltip.Span.make, {
        text: text
      })),
      errorMessage: props$1.error,
      required: props$1.required
    });
  };
  let InputRadioCardGroup = {
    make: Form__Elements__Inputs$Make$InputRadioCardGroup
  };
  let Form__Elements__Inputs$Make$InputPhone = props => {
    let __copyable = props.copyable;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let copyable = __copyable !== undefined ? __copyable : true;
    let props$1 = useField(props.field, hideError, hideRequired, undefined, undefined);
    let onChange = props$1.onChange;
    let inputRef = React.useRef(null);
    let onInputChange = newValue => {
      let cursor = Stdlib_Option.getOr(Stdlib_Option.flatMap(Primitive_option.fromNullable(inputRef.current), ReactDomElement.selectionStart), newValue.length);
      let significantBefore = significantCountBefore(newValue, cursor);
      let restricted = restrict(newValue);
      onChange(restricted);
      let nextFormatted = I18n.phoneNumberFormat(restricted);
      let nextCursor = positionAfterNthSignificant(nextFormatted, 0, significantBefore);
      requestAnimationFrame(param => Stdlib_Option.forEach(Primitive_option.fromNullable(inputRef.current), input => ReactDomElement.setSelectionRange(input, nextCursor, nextCursor)));
    };
    return JsxRuntime.jsx(InputTextField.make, {
      label: props.label,
      required: props$1.required,
      focused: props$1.focused,
      copyable: copyable,
      placeholder: props.placeholder,
      errorMessage: props$1.error,
      inputRef: inputRef,
      value: I18n.phoneNumberFormat(props$1.value),
      onChange: onInputChange,
      onFocus: props$1.onFocus,
      onBlur: props$1.onBlur
    });
  };
  let InputPhone = {
    make: Form__Elements__Inputs$Make$InputPhone
  };
  let Form__Elements__Inputs$Make$InputCheckbox = props => {
    let __disabled = props.disabled;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let disabled = __disabled !== undefined ? __disabled : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputCheckboxField.make, {
      label: props.label,
      text: props.text,
      required: props$1.required,
      errorMessage: props$1.error,
      value: props$1.value,
      disabled: disabled,
      onChange: props$1.onChange
    });
  };
  let InputCheckbox = {
    make: Form__Elements__Inputs$Make$InputCheckbox
  };
  let Form__Elements__Inputs$Make$InputToggleSwitch = props => {
    let __disabled = props.disabled;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let disabled = __disabled !== undefined ? __disabled : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputToggleSwitchField.make, {
      label: props.label,
      badge: props.badge,
      required: props$1.required,
      errorMessage: props$1.error,
      value: props$1.value,
      disabled: disabled,
      onChange: props$1.onChange
    });
  };
  let InputToggleSwitch = {
    make: Form__Elements__Inputs$Make$InputToggleSwitch
  };
  let Form__Elements__Inputs$Make$InputDate = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputDateField.make, {
      label: props.label,
      required: props$1.required,
      errorMessage: props$1.error,
      value: props$1.value,
      onChange: props$1.onChange
    });
  };
  let InputDate = {
    make: Form__Elements__Inputs$Make$InputDate
  };
  let Form__Elements__Inputs$Make$InputOptionalDate = props => {
    let __disabledFutureDays = props.disabledFutureDays;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let disabledFutureDays = __disabledFutureDays !== undefined ? __disabledFutureDays : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    let onChange = props$1.onChange;
    return JsxRuntime.jsx(InputDateField.make, {
      label: props.label,
      required: props$1.required,
      errorMessage: props$1.error,
      disabledFutureDays: disabledFutureDays,
      value: props$1.value,
      onChange: date => onChange(date),
      onRequestClear: () => onChange(undefined)
    });
  };
  let InputOptionalDate = {
    make: Form__Elements__Inputs$Make$InputOptionalDate
  };
  let Form__Elements__Inputs$Make$InputOptionalDateFastNav = props => {
    let __grow = props.grow;
    let __disabledFutureDays = props.disabledFutureDays;
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let disabledFutureDays = __disabledFutureDays !== undefined ? __disabledFutureDays : false;
    let grow = __grow !== undefined ? __grow : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    let onChange = props$1.onChange;
    return JsxRuntime.jsx(InputDateFieldFastNav.make, {
      label: props.label,
      required: props$1.required,
      errorMessage: props$1.error,
      disabledFutureDays: disabledFutureDays,
      value: props$1.value,
      onChange: date => onChange(date),
      onRequestClear: () => onChange(undefined),
      grow: grow
    });
  };
  let InputOptionalDateFastNav = {
    make: Form__Elements__Inputs$Make$InputOptionalDateFastNav
  };
  let Form__Elements__Inputs$Make$InputDateRange = props => {
    let __hideRequired = props.hideRequired;
    let __hideError = props.hideError;
    let hideError = __hideError !== undefined ? __hideError : false;
    let hideRequired = __hideRequired !== undefined ? __hideRequired : false;
    let props$1 = useField(props.field, hideError, hideRequired, true, undefined);
    return JsxRuntime.jsx(InputDateRangeField.make, {
      label: props.label,
      value: props$1.value,
      placeholder: props.placeholder,
      errorMessage: props$1.error,
      required: props$1.required,
      onChange: props$1.onChange
    });
  };
  let InputDateRange = {
    make: Form__Elements__Inputs$Make$InputDateRange
  };
  return {
    useField: useField,
    InputText: InputText,
    InputSuggestionComboBox: InputSuggestionComboBox,
    InputSelect: InputSelect,
    InputToggleButtonGroup: InputToggleButtonGroup,
    InputCountrySelect: InputCountrySelect,
    InputTextArea: InputTextArea,
    InputPassword: InputPassword,
    InputNumber: InputNumber,
    InputOptionalNumber: InputOptionalNumber,
    InputRadioGroup: InputRadioGroup,
    InputRadioCardGroup: InputRadioCardGroup,
    InputPhone: InputPhone,
    InputCheckbox: InputCheckbox,
    InputToggleSwitch: InputToggleSwitch,
    InputDate: InputDate,
    InputOptionalDate: InputOptionalDate,
    InputOptionalDateFastNav: InputOptionalDateFastNav,
    InputDateRange: InputDateRange
  };
}

export {
  PhoneNumberMask,
  Make,
}
/* I18n Not a pure module */
